export const API_BASE = import.meta.env.VITE_API_BASE_URL || 'https://api.memoriousai.com';

export const config = {
  API_BASE,
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,
  enableDevMode: import.meta.env.VITE_DEV_MODE === 'true' || import.meta.env.DEV,
} as const;